import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCommonDetails } from "redux/actions";
import { moveCartToNewStore, selectCurrentStore } from "redux/actions/store";
import LocationIcon from "assets/icons/location.svg";
import DownIcon from "assets/icons/down.svg";
import useOnClickOutside from "hooks/useOnClickOutside";
import { getLocalStorageValue, setLocalStorageValue } from 'config/helper';
import { useApiDefaults } from 'hooks/useApiDefaults';

const StoreLocationModal = (props) => {
  const location = useLocation();
  const { isShowDeliveryPopup, onClose, selectedStore } = props;
  const oldStoreRef = useRef(null);
  const [isShowSelectItems, setIsShowSelectItems] = useState(false);
  const [showStoreSelect, setStoreSelect] = useState(false);
  const apiDefaults = useApiDefaults();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const clientId = getLocalStorageValue("RSAclient-id");
  
  const storeList = useSelector(({ store }) => store.storeListData);
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn)

  const headerSectionData = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );

  const {
    productCartList: groceryProductCartList,
    cateringAndMealKitProductCartList,
  } = useSelector(({ cartWishlist }) => cartWishlist);

  const itemsAvailableInCart = (groceryProductCartList?.length || 0) + (cateringAndMealKitProductCartList?.length || 0) > 0;
  const isConfirmationRequired = isShowDeliveryPopup && isUserLoggedIn && itemsAvailableInCart;

  useEffect(() => {
    oldStoreRef.current = selectedStore;
  }, [])

  useEffect(() => {
    if (isConfirmationRequired) {
      setShowConfirmationModal(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirmationRequired])

  const refSelect = useRef();
  const refDelivery = useRef();

  useOnClickOutside(refDelivery, () => onClose());
  useOnClickOutside(refSelect, () => setIsShowSelectItems(false));

  const handleStoreChange = (selectedStore) => {
    setIsShowSelectItems(false);
    dispatch(selectCurrentStore(selectedStore));
    setLocalStorageValue('selected-store-id', selectedStore.ClientStoreId);
    setLocalStorageValue("selected-initial-store-id", selectedStore.ClientStoreId)
  };

  const handleCloseModal = () => {
    if (!getLocalStorageValue("selected-initial-store-id")) {
      setLocalStorageValue("selected-initial-store-id", getLocalStorageValue("selected-store-id"));
    }

    const aogEndPointURL = getLocalStorageValue("api-end-point-aog");
    if (apiDefaults.RSAClientId && aogEndPointURL) {
      const body = {
        ...apiDefaults,
        ClientStoreId: parseInt(selectedStore.ClientStoreId),
       RSAClientId: clientId,
      };
      dispatch(getCommonDetails(body));

      const oldStoreId = +oldStoreRef.current?.ClientStoreId
      const newStoreId = +selectedStore.ClientStoreId

      if (isUserLoggedIn && oldStoreId !== newStoreId) {
        moveCartToNewStore({...body, "FromClientStoreId": oldStoreId})
      }
    }
    
    if (location.pathname.startsWith("/weekly-ads/")) {
      const clientStoreId = selectedStore.ClientStoreId;
      const clientStoreName = encodeURIComponent(selectedStore.ClientStoreName);
      const url = `/weekly-ads/${clientStoreId}/${clientStoreName}`;
      navigate(url);
    }

    onClose();
  }

  function handleCancelClick() {
    setShowConfirmationModal(false)
    onClose()
  }

  if (showConfirmationModal) {
    return (
      <div className="modal-backdrop">
        <div className="modal-content">
        <button className="close-btn" onClick={handleCancelClick}>&times;</button>
        <div className="message">
          Changing the store will update your cart with items available at the
          new location. Product availability and pricing may vary by store.
        </div>
        <div className="message">Do you want to continue?</div>
        <div className="modal-actions">
          <button
            className="continue-btn"
            onClick={() => {
              setShowConfirmationModal(false)
              setConfirm(true)
            }}
          >
            Continue
          </button>
          <button
            className="cancel-btn"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
        </div>
        </div>
      </div>
    )
  }

  if (isConfirmationRequired && !confirm) {
    return null
  }

  return (
    <>
      {showStoreSelect && (
        <div className="modal-backdrop">
          <div className="modal store-selector-modal" ref={refDelivery}>
            <div className="store-selector-modal-header">
              <div className="logo-center-align">
                <img
                  src={headerSectionData.rsa_client_logo}
                  alt={headerSectionData.image_alt_text}
                />
              </div>
            </div>
            <div className="store-selector-modal-body">
              <div className="input-label"><strong>{headerSectionData ? headerSectionData.store_list_pop_lable : 'Select Store'}</strong></div>
              <div className="input">
                <div
                  ref={refSelect}
                  className="store-modal-select"
                  onClick={() => setIsShowSelectItems(!isShowSelectItems)}
                >
                  <div>
                    <div className="store-modal-location-icon">
                      <img src={LocationIcon} alt="LocationIcon" />
                    </div>
                    <div className="store-modal-down-icon">
                      <img src={DownIcon} alt="DownIcon" />
                    </div>
                    <span>
                      {selectedStore
                        ? selectedStore.ClientStoreName
                        : "Select Store"}
                    </span>
                  </div>
                  <div
                     className={
                      isShowSelectItems
                        ? "dropdown dropdown-show"
                        : "dropdown dropdown-hidden"
                    }
                  >
                    <div className="list-menu">
                      <ul>
                        {storeList &&
                          storeList.map((el) => {
                            return (
                              <li
                                className={
                                  el.ClientStoreId ===
                                    selectedStore?.ClientStoreId
                                    ? "selected"
                                    : ""
                                }
                                key={el.ClientStoreId}
                                onClick={() => handleStoreChange(el)}
                              >
                                {el.ClientStoreName}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  !!getLocalStorageValue("selected-store-id") && selectedStore
                    ? "continue-shopping-btn"
                    : "disable-btn continue-shopping-btn"
                }
              >
                <button onClick={handleCloseModal}>
                  <span>Continue</span>
                  <i className="fa-solid fa-right-long"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isShowDeliveryPopup && !showStoreSelect && (
        <div className="store-main-wrap">
          <div className="store-selector-modal">
            <div className="modal-content">
              {/* <button className="close-btn" onClick={onClose}>
                &times;
              </button> */}
            {clientId == 347 ? <h2>Select Recipient</h2> : <h2>Store Location</h2>}
              <p className="current-store-text"> {clientId == 347 ? "Your donations will go here:" : "You are currently shopping here:"}</p>
              <div className="store-details">
                <div className="store-logo-wrap">
                  <img src={headerSectionData.rsa_client_logo} alt={headerSectionData.image_alt_text} className="store-logo" />
                </div>
                <div className="store-info-wrapper">
                  <div className="store-info">
                    <h3>{selectedStore?.ClientStoreName}</h3>
                    <p>{selectedStore?.AddressLine1}</p>
                    <p>{selectedStore?.City+", "+selectedStore?.StateName+" - "+selectedStore?.ZipCode}</p>
                    {/* <p>{selectedStore?.AddressLine2}</p> */}
                    <p><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><path fill="currentColor" d="M478.94 370.14c-5.22-5.56-23.65-22-57.53-43.75c-34.13-21.94-59.3-35.62-66.52-38.81a3.83 3.83 0 0 0-3.92.49c-11.63 9.07-31.21 25.73-32.26 26.63c-6.78 5.81-6.78 5.81-12.33 4c-9.76-3.2-40.08-19.3-66.5-45.78s-43.35-57.55-46.55-67.3c-1.83-5.56-1.83-5.56 4-12.34c.9-1.05 17.57-20.63 26.64-32.25a3.83 3.83 0 0 0 .49-3.92c-3.19-7.23-16.87-32.39-38.81-66.52c-21.78-33.87-38.2-52.3-43.76-57.52a3.9 3.9 0 0 0-3.89-.87a322.4 322.4 0 0 0-56 25.45A338 338 0 0 0 33.35 92a3.83 3.83 0 0 0-1.26 3.74c2.09 9.74 12.08 50.4 43.08 106.72c31.63 57.48 53.55 86.93 100 133.22S252 405.21 309.54 436.84c56.32 31 97 41 106.72 43.07a3.86 3.86 0 0 0 3.75-1.26A337.7 337.7 0 0 0 454.35 430a322.7 322.7 0 0 0 25.45-56a3.9 3.9 0 0 0-.86-3.86" /></svg>&nbsp;{selectedStore?.StorePhoneNumber}</p>
                    {/* <p className="email-text"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25a.85.85 0 1 1 .9-1.44L12 11l6.7-4.19a.85.85 0 1 1 .9 1.44" /></svg>{selectedStore?.StoreEmail}</p> */}
                  </div>
                  <button className="make-home-store-btn">Select a different location</button>
                  <div
                  ref={refSelect}
                  className="store-modal-select"
                  onClick={() => setIsShowSelectItems(!isShowSelectItems)}
                >
                    <div className="store-modal-location-icon">
                      <img src={LocationIcon} alt="LocationIcon" />
                    </div>
                    <div className="store-modal-down-icon">
                      <img src={DownIcon} alt="DownIcon" />
                    </div>
                    <span>
                      {selectedStore
                        ? selectedStore.ClientStoreName
                        : "Select Store"}
                    </span>
                  <div
                     className={
                      isShowSelectItems
                        ? "dropdown dropdown-show"
                        : "dropdown dropdown-hidden"
                    }
                  >
                    <div className="list-menu">
                      <ul>
                        {storeList &&
                          storeList.map((el) => {
                            return (
                              <li
                                className={
                                  el.ClientStoreId ===
                                    selectedStore?.ClientStoreId
                                    ? "selected"
                                    : ""
                                }
                                key={el.ClientStoreId}
                                onClick={() => handleStoreChange(el)}
                              >
                                {el.ClientStoreName}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <div className="modal-actions">
                  <button className="continue-btn" onClick={handleCloseModal}>
                    {clientId == 347 ? "Continue" : "Continue to shop here"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StoreLocationModal;